module.exports = __webpack_public_path__ + "static/assets/8a9eaf608be455f87cd05897cd1e95d1.png";